
import {
  Component,
  Vue
} from 'vue-property-decorator'
/* import {
  Printd
} from 'printd' */
import VueAutonumeric from 'vue-autonumeric/src/components/VueAutonumeric.vue'
@Component({
  name: 'FDAPreview',
  components: {
    VueAutonumeric
  }
})
export default class FDAPreview extends Vue {
    protected showComponent = false
    protected document: any = null
    protected fda: any = {
      id: null,
      client: {},
      company: {},
      job: {},
      fda_date: null,
      description: null,
      payment_method: null,
      currency: null,
      company_address: null,
      client_address: null,
      bank_account: {},
      items: [],
      oil_quantity: null,
      water_quantity: null,
      total_oil_water_quantity: null,
      sub_total: null,
      advance_received: null,
      total: null,
      memorandum: null,
      remark: null,
      status: null,
      created_user: null,
      modified_user: null
    }

    public show (document: any) {
      this.showComponent = true

      this.populateFDA(document)
    }

    public hide () {
      this.cancel()
      this.showComponent = false
    }

    protected populateFDA (obj) {
      console.log('obj', obj)

      this.fda = obj

      this.fda.items = obj.items.map(line => ({
        ...line,
        isEdit: false,
        item: {
          id: line.item_id,
          name: line.item_name,
          description: line.description
        },
        tariffs: []
      }))

      console.log('fda', this.fda)
    }

    public cancel () {
      this.reset(this.fda)
    }

    protected reset (obj: any) {
      for (const key in obj) {
        obj[key] = null
      }
    }
}
